import React from 'react';
export function ScatteredSection() {
  return <section className="border-b border-line bg-carbon py-8 sm:py-10" data-id="element-168" data-mp="3gt7whwmtho6h">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-169" data-mp="3veb3lou4imf3">
        <div className="border-l-4 border-mod-yellow bg-panel2 p-4 sm:p-6" data-id="element-170" data-mp="cys798fsy5uk">
          <h2 className="text-[21px] font-bold leading-[1.05] text-white sm:text-[31px]" data-id="element-171" data-mp="d0v6mj2uhbby">
            😩 Stop searching through different references for every fault
          </h2>
          <p className="mt-3 text-[14px] font-medium leading-snug text-metal sm:text-[17px]" data-id="element-172" data-mp="mvdcnuvqhiyx">
            You already understand motorcycle repair. The problem is wasting time
            jumping between scattered information, diagrams and references just to
            figure out what needs checking next. Open the system, identify the
            symptom and follow the relevant diagnostic path.{' '}
            <strong className="font-bold text-white" data-id="element-173" data-mp="2xpj4yc3rjifj">
              Less guessing. More structured diagnostics.
            </strong>
          </p>
        </div>
      </div>
    </section>;
}